import { QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './index.css'

import { configureApiClient } from '@gta/api-client'

import { setUnauthorizedHandler } from '@/lib/api'
import { authKeys } from '@/lib/auth'
import { queryClient } from '@/lib/query-client'
import { router } from '@/router'

// 把 api 层的 401 兜底(整页跳转)换成 router 的 SPA 跳转,并顺手把身份缓存置空。
const onUnauthorized = (next: string) => {
  queryClient.setQueryData(authKeys.me(), null)
  if (router.state.location.pathname === '/login') return
  void router.navigate({ to: '/login', search: { next }, replace: true })
}
setUnauthorizedHandler(onUnauthorized)
// 生成 hooks(@gta/api-client)与手写 api 层同一套 401 语义。
configureApiClient({ onUnauthorized })

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('挂载失败:index.html 里找不到 #root 节点')
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
